import { render, staticRenderFns } from "./schoolRoll.vue?vue&type=template&id=cad926f8&scoped=true&"
import script from "./schoolRoll.vue?vue&type=script&lang=js&"
export * from "./schoolRoll.vue?vue&type=script&lang=js&"
import style0 from "./schoolRoll.vue?vue&type=style&index=0&id=cad926f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad926f8",
  null
  
)

export default component.exports